import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpEventType, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class HttpService {
  constructor(private http: HttpClient) {}

  
getMethod(url: string): Observable<any> {
    return this.http.get(url);
  }

  getWithProgress<T>(url: string): Observable<HttpEvent<T>> {
    return this.http.get<T>(
      url,
      {responseType: 'json', observe: 'events', reportProgress: true}
    );
  }
  postWithProgress<T>(url: string, data?: any): Observable<HttpEvent<T>> {
    return this.http.post<T>(
      url,
      data,
      {responseType: 'json', observe: 'events', reportProgress: true}
    );
  }

  postMethod(url: string, data?: any): Observable<any> {
    return this.http.post(url, data);
  }

  putMethod(url: string, data?: any): Observable<any> {
    return this.http.put(url, data);
  }

  patchMethod(url: string, data?: any): Observable<any> {
    return this.http.patch(url, data);
  }

  deleteMethod(url: string, data?: any): Observable<any> {
    return this.http.delete(url, { body: data });
  }

  postFileMethod(url: string, data: any): Observable<any> {
    let headers = new HttpHeaders();
    return this.http
      .post(url, data, {
        headers,
        observe: "events",
        reportProgress: true,
      })
      .pipe(
        map((event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            const percentDone = Math.round((100 * event.loaded) / event.total);
            return { status: "progress", percent: percentDone };
          }
          if (event.type === HttpEventType.Response) {
            return event.body;
          }
        })
      );
  }

  //landing screen API method
  getZone(url: string): Observable<any> {
    return this.http.get(url, { observe: "response" }).pipe(
      map((data) => {
        return data;
      })
    );
  }
  postNewsletter(url: string, data?: any): Observable<any> {
    return this.http.post(url, data, { observe: "response" }).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getBlobMethod(url: string): Observable<any> {
    let headers = new HttpHeaders();
    return this.http.get(url, { headers: headers, responseType: "blob" });
  }

  getPDFMethod(url: string, data: any): Observable<any> {
    let headers = new HttpHeaders();
    return this.http.post(url, data, {
      headers: headers,
      responseType: "blob",
    });
  }

  getMockFile(url: string) {
    return this.http.get(url);
  }
}
